module.exports = __webpack_public_path__ + "static/media/teams.626d6b6c.png";